import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { useHistory, Link, Redirect, useLocation } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

const Login = ({ error }) => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory()
  const location = useLocation();
  useEffect(() => {
    //console.log(location.state)
    if(location.state)
      if(location.state.from === "CartPage"){
        enqueueSnackbar("You must be logged in to access checkout page", {
          autoHideDuration: 3000,
          variant: "error"
        })
      }
  },[])
  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  const login = async (formData) => {
    const valid = validateInput(formData)

    if(!valid)
      return;

    setShowButton(false)
    let url = `${config.endpoint}/auth/login`

    axios.post(url, formData).then(res => {
      console.log(res)
      let data = res.data
      persistLogin(data.token, data.username, data.balance)
      showSnack("Logged In", "success")
      setRedi(true)
      setShowButton(true)
    }).catch(err => {
      showSnack(err.response.data.message, "error")
      setShowButton(true)
    })
    
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = (data) => {
    if(data.username.length === 0){
      showSnack("Username is a required field", "warning")
      return false;
    }

    if(data.password.length === 0){
      showSnack("Password is a required field", "warning")
      return false;
    }

    return true;
  };
  const showSnack = (mess, type) => {
    enqueueSnackbar(mess, {
      autoHideDuration: 3000,
      variant: type
    })
  }
  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const [user, setUser] = useState("")
  const [pass, setPass] = useState("")
  const [showButton, setShowButton] = useState(true)

  const persistLogin = (token, username, balance) => {
      localStorage.setItem("username", username)
      localStorage.setItem("token", token)
      localStorage.setItem("balance", balance)
    
  };

  const [redi, setRedi] = useState(false)

  
  return (
    redi ? <Redirect to="/" /> : 
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true}/>
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Login</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            onChange={(e) => {
              setUser(e.target.value)
            }}
            value={user}
          />
          <TextField 
            id="password"
            label="Password"
            variant="outlined"
            title="Password"
            name="password"
            type="password"
            placeholder="Enter Password"
            fullWidth
            onChange={(e) => {
              setPass(e.target.value)
            }}
          />
          {showButton ? <Button className="button" variant="contained" onClick={(e) => login({username: user, password: pass})}>
            LOGIN TO QKART
           </Button> : <CircularProgress className="cp"/> }
           <p className="secondary-action">
           Don't have an account? {" "}
             <Link className="link" to="/register">
              Register Now
             </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
